// Libs
import { SWRConfiguration } from 'swr';
// App
import { retryUnlessClientError } from './swr-error-retry.utils';

export const SWR_DEFAULT_CONFIG: SWRConfiguration = {
  errorRetryCount: 3,
  onErrorRetry: retryUnlessClientError,
};
